module.exports = __webpack_public_path__ + "static/media/4@3x.3de93467.png";